import { render, staticRenderFns } from "./VideoMatrixWidget.vue?vue&type=template&id=f47041b8&"
import script from "./VideoMatrixWidget.vue?vue&type=script&lang=js&"
export * from "./VideoMatrixWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports